var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialMediaSnapchat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3036 9.5443C21.3036 -1.8481 6.44643 -1.8481 6.44643 9.5443V11.443H4.43081C3.709 11.443 3.41186 12.3911 3.99995 12.8203L6.44643 14.6076C6.03414 16.0848 4.34167 19.2911 0.875 20.3038C1.28729 20.9367 2.48452 22.2025 3.97024 22.2025L5.20833 24.1013L8.30357 23.4684C9.33491 24.3127 11.894 26 13.875 26C15.856 26 18.4151 24.3127 19.4464 23.4684L22.5417 24.1013L23.7798 22.2025C25.2655 22.2025 26.4627 20.9367 26.875 20.3038C23.4083 19.2911 21.7159 16.0848 21.3036 14.6076L23.75 12.8203C24.3381 12.3911 24.041 11.443 23.3192 11.443H21.3036V9.5443Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMediaSnapchat);
export default __webpack_public_path__ + "static/media/socialMediaSnapchat.32bb11eae2b64b6945dbcf31f99fdaa8.svg";
export { ForwardRef as ReactComponent };